// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"e620b769","428":"a571b122","498":"289a9f52","894":"289a9f52","964":"3532f5ad"}[chunkId] + ".chunk.css";
};